export default "__VITE_ASSET__DoAn9Sc3__"